import React from 'react';
import { Sparkles, Calendar, MapPin } from 'lucide-react';
import { events } from '../../../../data/events';

const StarLinkSection = () => {
  // Get the Starlink event data
  const starlinkEvent = events.eventSeries?.events?.find(event => event.title.includes('Starlink'));

  if (!starlinkEvent) return null;

  return (
    <div className="w-full max-w-[1920px] px-4 sm:px-8 md:px-12 lg:px-16 xl:px-24 py-12 bg-Color-White">
      {/* Section Title */}
      <div className="mb-8">
        <h2 className="text-3xl sm:text-4xl font-bold text-Color-Black font-['Montserrat'] flex items-center gap-3">
          <Sparkles className="w-8 h-8 text-Color-Brand-Green" />
          IEEE Starlink Installation Project
        </h2>
        <div className="h-1 w-32 bg-Color-Brand-Green rounded-full mt-3"></div>
      </div>

      {/* Main Content Container */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
        {/* Left Content - Image */}
        <div className="flex flex-col justify-center">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src={starlinkEvent.image} 
              alt={starlinkEvent.title}
              className="w-full h-[400px] lg:h-[500px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-Color-Black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="flex items-center gap-2 text-Color-White mb-2">
                <MapPin className="w-5 h-5" />
                <span className="font-['Montserrat'] font-semibold">Dellawa Maha Vidyalaya</span>
              </div>
              <div className="flex items-center gap-2 text-Color-White">
                <Calendar className="w-5 h-5" />
                <span className="font-['Montserrat']">August 6th, 2025</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Content - Description */}
        <div className="flex flex-col justify-center space-y-6">
          <div className="border-l-4 border-Color-Brand-Green pl-6">
            <h3 className="text-2xl sm:text-3xl font-semibold text-Color-Black font-['Montserrat'] mb-4">
              Internet for All Initiative
            </h3>
            <p className="text-base sm:text-lg text-Color-Black font-['Montserrat'] leading-relaxed mb-4">
              {starlinkEvent.brief}
            </p>
          </div>

          {/* Key Highlights */}
          <div className="bg-Color-Foreground/20 rounded-xl p-6 border-l-4 border-Color-Brand-Green">
            <h4 className="text-xl font-semibold text-Color-Black font-['Montserrat'] mb-4">
              Project Highlights
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="text-Color-Brand-Green text-xl font-bold">•</span>
                <span className="text-Color-Black font-['Montserrat']">Smart Classroom & Starlink connection donated</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-Color-Brand-Green text-xl font-bold">•</span>
                <span className="text-Color-Black font-['Montserrat']">Awarded by IEEE ComSoc and IEEE Tech4Good (T4G)</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-Color-Brand-Green text-xl font-bold">•</span>
                <span className="text-Color-Black font-['Montserrat']">Part of 25th Anniversary celebrations</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-Color-Brand-Green text-xl font-bold">•</span>
                <span className="text-Color-Black font-['Montserrat']">Bridging digital divides and empowering learners</span>
              </li>
            </ul>
          </div>

          {/* Additional Info Badge */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-Color-Brand-Green/10 border border-Color-Brand-Green/20 px-6 py-3 rounded-full">
              <Sparkles className="w-5 h-5 text-Color-Brand-Green" />
              <span className="text-Color-Brand-Green font-semibold font-['Montserrat']">
                Transforming Education Through Connectivity
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StarLinkSection;
